import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import Modal from '@mui/material/Modal';
import TextField from '@mui/material/TextField';
import CheckCircleIcon from '@mui/icons-material/CheckSharp';

import Button from 'src/component/UI/Button';
import { getSingularWorkTicketLabel } from 'src/module/authentication/selector';
import { getIntegrations } from 'src/module/integration/selector';
import { fetchIntegrations } from 'src/module/integration/action';
import { useTranslation } from 'src/i18n';

import './NotificationNumberModal.scss';

export default function NotificationNumberModal (props) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [notificationNumber, setNotificationNumber] = useState('');
  const [notificationDescription, setNotificationDescription] = useState('');

  const singularWorkTicketLabel = useSelector(getSingularWorkTicketLabel);

  const handleSubmit = (e) => {
    e.preventDefault();
    props.handleSubmit(notificationNumber, notificationDescription);
    setNotificationNumber('');
    setNotificationDescription('');
  };

  return (
    <Modal open={props.open} onClose={props.handleClose} aria-labelledby='notification-number-modal-title' >
      <div className='modal notification-number-modal'>
        <h2 id='notification-number-modal-title'>{t('notificationModal.validAlarms')}</h2>
        <form noValidate autoComplete='off' onSubmit={handleSubmit}>
          <div className='form-field'>
            <TextField
              value={notificationNumber}
              onChange={(e) => { setNotificationNumber(e.target.value); }}
              label={t('notificationModal.number', { label: singularWorkTicketLabel || t('workTickets.singular') })}
              placeholder={t('notificationModal.enterNumber', { label: singularWorkTicketLabel || t('workTickets.singular') })}
              variant='outlined'
              InputLabelProps={{ shrink: true }}
              fullWidth
              required
            />
          </div>

          <div className='form-field'>
            <TextField
              value={notificationDescription || ''}
              onChange={(e) => { setNotificationDescription(e.target.value); }}
              label={t('notificationModal.description', { label: singularWorkTicketLabel || t('workTickets.singular') })}
              placeholder='Enter description...'
              variant='outlined'
              InputLabelProps={{ shrink: true }}
              fullWidth
            />
          </div>

          <div className='button-bar'>
            <Button onClick={props.handleClose}>{t('common.cancel')}</Button>
            <Button type='submit' icon={<CheckCircleIcon style={{ fontSize: 14 }} />} cta>{t('notificationModal.validate')}</Button>
          </div>
        </form>
      </div>
    </Modal>
  );
}

NotificationNumberModal.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired
};
